import React from "react";
import BrowseByRegion from "./BrowseByRegion";
import BrowseByList from "./BrowseByList";
import { withRouter } from "react-router-dom";

const ByLocation = props => {
  const getText = path => {
    return !!path && path.includes("/services/") ? "Services" : "Software";
  };
  return (
    <>
      <section>
        <div className="geo-location-landing-header">
          <div className="container-fluid">
            <h1>{`${props.category_name} ${getText(props.match.path)} ${
              !!props.location_page_title ? props.location_page_title : ""
            }`}</h1>
          </div>
        </div>
      </section>
      <section>
        <div className="browse_txt_block">Browse by City, State or Country</div>
      </section>
      <section>
        <div className="middleSection vendor-category geo-location-content-section">
          <div className="container">
            <div className="WidthContain">
              <BrowseByRegion topLocations={props.top_locations} />
              <div className="article_learn_category geo-location-individual-content-section">
                <div className="browse-landing-listing">
                  {((!!props.usa_cities && props.usa_cities.length > 0) ||
                    (!!props.intl_cities && props.intl_cities.length > 0)) && (
                    <>
                      <BrowseByList
                        heading="Search by City"
                        list={[...props.usa_cities, ...props.intl_cities]}
                      />
                    </>
                  )}

                  {!!props.usa_states && props.usa_states.length > 0 && (
                    <>
                      <hr />
                      <BrowseByList
                        heading="Search by State"
                        list={props.usa_states}
                      />
                    </>
                  )}

                  {!!props.countries && props.countries.length > 0 && (
                    <>
                      <hr />
                      <BrowseByList
                        heading="Search by Country"
                        list={props.countries}
                      />
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default withRouter(ByLocation);
